import { Cart, cartAtom } from "core/cart";
import { cn, useClickOutside } from "core/shared";
import { useEffect } from "react";
import { useCartEvents } from "~/modules/our-cakes/hooks";
import { cartDrawerAtom } from "~/modules/shared/atoms/cart-drawer.atom";
import { useFetch } from "~/shared/hooks";
import { URLS } from "~/shared/urls";
import { CartDrawerEmptyState } from "./CartDrawerEmptyState";
import { CartDrawerFooter } from "./CartDrawerFooter";
import { CartDrawerItems } from "./CartDrawerItems";
import { CartHeader } from "./CartHeader";

export function CartDrawer() {
  useCartEvents();

  const drawerRef = useClickOutside(() => cartDrawerAtom.close());

  const { load } = useFetch<{ cart: Cart }>(URLS.cart.api, {
    updateState: false,
  });

  const cart = cartAtom.use("cart");

  const cardDrawerOpened = cartDrawerAtom.useOpened();

  const totalItems = cart && cart.items ? cart.items.length : 0;

  useEffect(() => {
    if (cardDrawerOpened && (!cart || cart.items?.length === 0)) {
      load().then((data) => {
        cartAtom.change("cart", data.cart);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardDrawerOpened, cart?.items?.length]);

  useEffect(() => {
    if (cardDrawerOpened) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [cardDrawerOpened]);

  if (!cardDrawerOpened) return null;

  return (
    <>
      <div
        onClick={() => cartDrawerAtom.close()}
        className={cn(
          "fixed inset-0 z-50 bg-black/40 transition-all duration-300",
          cardDrawerOpened
            ? "animate-fade-in opacity-100"
            : "pointer-events-none opacity-0",
        )}
      />
      <div
        ref={drawerRef}
        className={cn(
          "animate-fade-left fixed top-0 right-0 z-[60] flex h-dvh w-full flex-col border-l bg-gray-50 sm:w-[495px]",
        )}
      >
        <CartHeader totalItems={totalItems} />
        <div className="flex-1 overflow-y-auto">
          {totalItems > 0 ? <CartDrawerItems /> : <CartDrawerEmptyState />}
        </div>
        {!!totalItems && <CartDrawerFooter />}
      </div>
    </>
  );
}
